module.exports = __webpack_public_path__ + "img/Henrique.a08ee56c.jpg";